export const seniorSchoolSubjects = [
  { name: "Accounting", department: ["commercial"] },
  { name: "Agriculture", department: ["science"] },
  { name: "Animal Husbandry", department: ["science"] },
  { name: "Arabic", department: ["science"] },
  { name: "Biology", department: ["science"] },
  { name: "Catering Craft Practice", department: ["science"] },
  { name: "Chemistry", department: ["science"] },
  { name: "Civic Education", department: ["science", "commercial"] },
  { name: "Commerce", department: ["science", "commercial"] },
  { name: "Data Processing", department: ["science"] },
  { name: "Economics", department: ["science", "commercial", "art"] },
  { name: "English Language", department: ["science", "commercial", "art"] },
  { name: "Further Mathematics", department: ["science"] },
  { name: "Geography", department: ["science"] },
  { name: "Government", department: ["art"] },
  { name: "IRS", department: ["science", "art", "commercial"] },
  { name: "Literature In English", department: ["science"] },
  { name: "Marketing", department: ["science", "commercial"] },
  { name: "Mathematics", department: ["science", "commercial"] },
  { name: "Physics", department: ["science"] },
  { name: "Yoruba Language", department: ["art", "science", "commercial"] },
  { name: "Quran", department: ["art", "science", "commercial"] },
];

export const juniorSchoolSubjects = [
  "English Language",
  "Mathematics",
  "Qualitative Reasoning",
  "Verbal Reasoning",
  "Arabic",
];
export const allSubjects = [
  "Accounting",
  "Agriculture",
  "Animal Husbandry",
  "Arabic",
  "Biology",
  "Catering Craft Practice",
  "Chemistry",
  "Civic Education",
  "Commerce",
  "Data Processing",
  "Economics",
  "English Language",
  "Further Mathematics",
  "Geography",
  "Government",
  "IRS",
  "Literature In English",
  "Marketing",
  "Mathematics",
  "Physics",
  "Yoruba Language",
];
